import { createSlice } from "@reduxjs/toolkit";
import { addMembership, editMembership, getMembership, getMembershipList } from "../services/membership-services";


const initialState = {
  memberships: [],
  membership: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const membershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMembershipList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getMembershipList.fulfilled, (state, action) => {
        state.memberships = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getMembershipList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getMembership.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getMembership.fulfilled, (state, action) => {
        state.memberships = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getMembership.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addMembership.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addMembership.fulfilled, (state, action) => {
        state.memberships = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addMembership.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editMembership.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editMembership.fulfilled, (state, action) => {
        state.memberships = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editMembership.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      });
  },
});
export const { resetSuccess, resetState, resetError } = membershipSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default membershipSlice.reducer;
